import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Unfound from './views/404/index.vue'
import News from './views/news/news.vue'
import Recruit from './views/recruit/Recruit.vue'
import Zpgw from './views/recruit/child/zpgw/zpgw.vue'
import Zpgwxq from './views/recruit/child/zpgw/zpgwxq.vue'
import Zpxz from './views/recruit/child/zpxz.vue'

// 首页
// import Indexnews from "./views/index/indexnews.vue";
// import Indexnotice from "./views/index/indexnotice.vue";
//医药共享仓
import Warehouse from './views/warehouse/index.vue'
import Wconcept from './views/warehouse/warehouseList/wconcept.vue'
import Wflow from './views/warehouse/warehouseList/wflow.vue'
import Wstage from './views/warehouse/warehouseList/wstage.vue'

//走进固德
import Gygd from './views/gdyy/index.vue'
import Gdyy from './views/gdyy/gdyyList/gdyy.vue'
import Zzjg from './views/gdyy/gdyyList/zzjg.vue'
import Fzlc from './views/gdyy/gdyyList/fzlc.vue'
import Ldgh from './views/gdyy/gdyyList/ldgh.vue'
import Zlfz from './views/gdyy/gdyyList/zlfz.vue'
//企业新闻
import Qyxw from './views/news/newsList/qyxw.vue'
import Qyxwxq from './views/news/newsList/qyxwxq.vue'
import Hyxw from './views/news/newsList/hyxw.vue'
import Hyxwxq from './views/news/newsList/hyxwxq.vue'
import Flfg from './views/news/newsList/flfg.vue'
import Flfgxq from './views/news/newsList/flfgxq.vue'
import Gsgg from './views/news/newsList/gsgg.vue'
import Gsggxq from './views/news/newsList/gsggxq.vue'
//联系我们
import Contactus from './views/contactus/index.vue'
//在线商城
import Shop from './views/shop/shop.vue'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to,from,saveTop) {
    if(saveTop) {
      return saveTop
    } else {
      return { x: 0 , y :0 }
    }
  },
  routes: [{
    path: '/',
    components: { home: Home },
    },{
      path: '/news',
      components: {
        news: News
      },children: [{
        path: 'qyxw',
        name: 'qyxw',
        components: {
          qyxw: Qyxw
        },children: [{
          path: 'qyxwxq',
          name: 'qyxwxq',
          components: {
            qyxwxq:Qyxwxq
          }
        }]
      },
    {
      path: 'hyxw',
      components: {
        hyxw: Hyxw
      },
      children: [{
        path: 'hyxwxq',
        name: 'hyxwxq',
        components: {
          hyxwxq: Hyxwxq
        }
      }]
    },{
      path: 'gsgg',
      name: 'gsgg',
      components: {
        gsgg: Gsgg
      },
      children: [{
        path: 'gsggxq',
        name: 'gsggxq',
        components: {
          gsggxq: Gsggxq
        }
      }]
    },{
      path: 'flfg',
      components: {
        flfg: Flfg
      },
      children: [{
        path: 'flfgxq',
        name: 'flfgxq',
        components: {
          flfgxq: Flfgxq
        }
      }]
    }]
  },{
    path: '/recruit',
    components: { recruit: Recruit },
    children: [{
      path: 'zpgw',
      components: { zpgw:Zpgw },
      children: [{
        path: 'zpgwxq',
        name: 'zpgwxq',
        components: {
          zpgwxq: Zpgwxq
        }
      }]
    },{
      path: 'zpxz',
      components: {
        zpxz: Zpxz
      }
    }]
  },{
    path: '/gygd',
    components: {
      gygd: Gygd
    },
    children:[{
      path: 'gdyy',
      name: 'gdyy',
      components: {
        gdyy: Gdyy
      }
    },{
      path: 'zzjg',
      name: 'zzjg',
      components: {
        zzjg: Zzjg
      }
    },{
      path: 'fzlc',
      name: 'fzlc',
      components: {
        fzlc: Fzlc
      }
    },{
      path: 'zlfz',
      name: 'zlfz',
      components: {
        zlfz: Zlfz
      }
    },{
      path: 'ldgh',
      name: 'ldgh',
      components: {
        ldgh: Ldgh
      }
    }]
  },{//医药共享仓
    path: '/warehouse',
    components: {
      warehouse: Warehouse
    },
    children: [
      { path: 'wconcept', name: 'wconcept', components: { wconcept: Wconcept } },
      { path: 'wflow', name: 'wflow', components: { wflow: Wflow } },
      {path: 'wstage',name: 'wstage',components: {wstage: Wstage}}
    ]
  },{
    path: '/contactus',
    name: 'contactus',
    components: {
      contactus: Contactus
    }
  },{
    path: '/shop',
    name: 'shop',
    components: {
      shop: Shop
    }
  },
  {
    path:'*',
    components: {
      unfound:Unfound
    }
    },
  ]
 
})
